import React from 'react';
import { jUserLittle, UserLevel, UserVariant } from 'jamespot-user-api';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { useTheme } from 'styled-components';

export type JRCUserStatusIconProps = {
    user: jUserLittle;
    isUserActive?: boolean;
};

export const JRCUserStatusIcon = ({ user, isUserActive }: JRCUserStatusIconProps) => {
    const theme = useTheme();
    let icon = undefined;
    if (user.level === UserLevel.ADMIN && isUserActive) {
        icon = <JRCIcon isMargin={false} color={theme.color.primary} size={14} name={'icon-fs-shield'} />;
    }
    if (user.variant === UserVariant.EXTRABOT) {
        icon = <JRCIcon isMargin={false} color={theme.color.primary} size={18} name={'icon-extra-bot'} />;
    }

    return icon ?? null;
};
